<template>
  <div class="container" id="home-container">
    <transition appear name="fade">
    <div class="grids-wrapper">
      <div class="main-grid">
        <div class="item box-a"></div>
        <div class="item box-b"></div>
        <div class="item box-c"></div>
        <div class="item box-d">
          <h1>be generative</h1>
        </div>
        <div class="item box-e">
          <img src="../img/beGenerativeLogo.png" />
        </div>
        <div class="item box-f"></div>
        <div class="item box-g">
          <h2>KOH</h2>
        </div>
        <div class="item box-h"></div>
        <div class="item box-i">
          <h2>YAMAKAWA</h2>
        </div>
        <div class="item box-j">
          <router-link to="/works" class="info-item link-in-grid .not-router-link-active" exact>
            <span style>￣</span>
            <p>works</p>
          </router-link>
          <router-link to="/about" class="info-item link-in-grid .not-router-link-active" exact>
            <span style>￣</span>
            <p>about</p>
          </router-link>
        </div>
        <div class="item box-k"></div>
      </div>
      <div class="background-grid">
        <div class="background-item back-v"></div>
        <div class="background-item back-w"></div>
        <div class="background-item back-x home-bg" id="home-p5-canvas"></div>
        <div class="background-item back-y"></div>
        <div class="background-item back-z"></div>
      </div>
    </div>
    </transition>
  </div>
</template>

<script>
export default {
  mounted () {
    let particles = require('@/js/Particles.js')
    const P5 = require('p5')
    // eslint-disable-next-line no-new
    new P5(particles.main)
  }
}
</script>

<style lang="scss">
.fade-enter-active {
  transition: all 5s cubic-bezier(0.19, 1, 0.22, 1);
}
.fade-leave-active {
  transition: all 1s cubic-bezier(0.895, 0.03, 0.685, 0.22);
}

.fade-enter {
  opacity: 0;
}
.fade-leave-to {
  opacity: 0;
}
$xl: 1440px;
$lg: 1080px;
$md: 768px;
$sm: 544px;

$xlMag: 0.88;
$lgMag: 0.64;
$mdMag: 0.5;
@mixin xl {
  @media (max-width: ($xl)) {
    @content;
  }
}
@mixin lg {
  @media (max-width: ($lg)) {
    @content;
  }
}
@mixin md {
  @media (max-width: ($md)) {
    @content;
  }
}
@mixin sm {
  @media (max-width: ($sm)) {
    @content;
  }
}

.container#home-container {
  height: 90vh;
  width: 1200px;
  display: flex;
  align-items: center;
  margin: 0 auto;
  @include xl {
    width: 1200px * $xlMag;
  }
  @include lg {
    width: 1200px * $lgMag;
  }
  @include md {
    width: 1200px * $mdMag;
  }
  .grids-wrapper {
    position: relative;
    width: 100%;
    height: 724px;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;

    @include xl {
      height: 724px * $xlMag;
    }
    @include lg {
      height: 724px * $lgMag;
    }
    @include md {
      height: 724px * $mdMag;
    }
    .main-grid {
      display: grid;
      grid-template-columns: repeat(10, 1fr);
      grid-template-rows: 1fr 1fr 10fr 1fr 1fr;
      /* background-color: #eee; */
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      .item {
        // border: rgb(84, 84, 84) 1px solid;
        color: #fff;
        box-sizing: border-box;
        border-radius: 5px;
        display: flex;
        align-items: center;
        background: none;
      }
      .box-a {
        grid-column: 1/11;
      }
      .box-b {
        grid-column: 1/8;
      }
      .box-c {
        grid-column: 8/11;
      }
      .box-d {
        /* be-generative */
        grid-column: 1/8;
        h1 {
          font-family: ambroise-francois-std, serif;
          font-weight: 600;
          font-style: normal;
          font-size: 180px;
          letter-spacing: 0.05em;
          @include xl {
            font-size: 180px * $xlMag;
          }
          @include lg {
            font-size: 180px * $lgMag;
          }
          @include md {
            font-size: 180px * $mdMag;
          }
        }
      }
      .box-e {
        grid-column: 8/11;
        grid-row: 3/5;
        position: relative;
        img {
          position: absolute;
          left: 0;
          bottom: 2%;
          width: 91.5%;
          pointer-events: none;
        }
      }
      .box-f {
        display: none;
      }
      .box-g {
        /* KOH */
        grid-column: 2/8;
        h2 {
          font-family: brandon-grotesque, sans-serif;
          font-style: normal;
          font-size: 40px;
          font-weight: bold;
          letter-spacing: 0.1em;
          position: relative; /*justify the baseline*/
          margin: 0;
          bottom: -20px;
          @include xl {
            font-size: 40px * $xlMag;
            bottom: -20px * $xlMag;
          }
          @include lg {
            font-size: 40px * $lgMag;
            bottom: -20px * $lgMag;
          }
          @include md {
            font-size: 40px * $mdMag;
            bottom: -26px * $mdMag;
          }
        }
      }
      .box-h {
        display: none;
      }
      .box-i {
        /* YAMAKAWA */
        grid-column: 2/8;
        @extend .box-g;
        h2 {
          top: -4px;
          @include xl {
            font-size: 40px * $xlMag;
            top: -4px * $xlMag;
          }
          @include lg {
            font-size: 40px * $lgMag;
            top: -4px * $lgMag;
          }
          @include md {
            font-size: 40px * $mdMag;
            top: 0px * $mdMag;
          }
        }
      }
      .box-j {
        /* links_list */
        grid-column: 8/10;
        list-style: none;
        justify-content: space-between;
        .link-in-grid {
          color: #fff;
          font-weight: 600;
          font-size: 18px;
          margin: 0;
          position: relative;
          &:hover {
            p {
              color: #444450;
            }
          }
          @include md {
            font-size: 14px;
          }
          p {
            padding: 8px 8px 8px 0;
            margin: 0;
            color: #fff;
            @include md {
              padding-top: 4px;
            }
          }
          span {
            color: #444450;
            position: absolute;
            top: 0px;
          }
        }
      }
      .box-k {
        display: none;
      }
    }

    div.background-grid {
      @extend .main-grid;
      z-index: -1;
    }
    div.background-item {
      font-weight: 600;
    }
    .back-v {
      grid-column: 1/11;
    }
    .back-w {
      grid-row: 2/5;
    }
    .back-x {
      grid-column: 2/10;
      grid-row: 2/5;
      background-color: #cdd4d4;
      border: 1px solid #fff;
    }
    .back-y {
      grid-row: 2/5;
    }
    .back-z {
      grid-column: 1/11;
    }
  }
}

//mobile version
@include sm {
  .container#home-container {
    height: 100vh; //
    width: 90%; //
    // overflow: hidden;
    .grids-wrapper {
      height: 100%; //
      .main-grid {
        grid-template-columns: 1fr 4fr 1fr; //
        grid-template-rows: 1.13fr 0.87fr 8fr 1fr 1fr 1.5fr 1fr; //
        height: 100%; //
        .item {
          //   border: rgb(84, 84, 84) 1px solid;
        }
        .box-a {
          display: none; //
        }
        .box-b {
          display: none; //
        }
        .box-c {
          display: none; //
        }
        .box-d {
          /* be-generative */
          grid-column: 1/4; //
          grid-row: 1/3; //
          justify-content: center;
          h1 {
            font-size: 23vw; //
          }
        }
        .box-e {
          grid-column: 2/3; //
          grid-row: 3/4; //
          img {
            position: relative;
            margin: 0 auto;
            bottom: 0%; //
            width: 100%; //
            max-width: 224px; //
          }
        }
        .box-g {
          /* KOH */
          grid-column: 2/3; //
          grid-row: 4/5; //
          h2 {
            font-size: 10vw; //
            bottom: -20px; //
          }
        }
        .box-h {
          display: none;
        }
        .box-i {
          /* YAMAKAWA */
          grid-column: 2/3; //
          grid-row: 5/6; //
          h2 {
            font-size: 10vw; //
            top: -4px; //
          }
        }
        .box-j {
          /* links_list */
          grid-column: 2/3; //
          grid-row: 6/7; //
          .link-in-grid {
            p {
              font-size: 20px; //
            }
            span {
              position: absolute;
              top: 0px;
            }
          }
        }
        .box-k {
          display: none;
        }
      }

      div.background-grid {
        grid-template-columns: 1fr 4fr 1fr; //
        grid-template-rows: 1.13fr 0.87fr 8fr 1fr 1fr 1.5fr 1fr; //
        height: 100%; //
      }
      div.background-item {
        font-weight: 800;
      }
      .back-v {
        grid-column: 1/11;
        display: none; //
      }
      .back-w {
        grid-row: 2/5;
        display: none; //
      }
      .back-x {
        grid-column: 1/4; //
        grid-row: 2/7; //
      }
      .back-y {
        grid-row: 2/5;
        display: none;
      }
      .back-z {
        grid-column: 1/11;
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue